import { getPortalAuthConfig } from "../portals/portalConfig";

export function getAuthToken(): string | null {
  return localStorage.getItem(getPortalAuthConfig().tokenKey);
}

export function setAuthToken(token: string): void {
  localStorage.setItem(getPortalAuthConfig().tokenKey, token);
}

export function setAuthProfile(profile: unknown): void {
  localStorage.setItem(
    getPortalAuthConfig().profileKey,
    JSON.stringify(profile),
  );
}

export function getAuthProfileRaw(): string | null {
  return localStorage.getItem(getPortalAuthConfig().profileKey);
}

export function clearPortalAuth(): void {
  const { tokenKey, profileKey } = getPortalAuthConfig();
  localStorage.removeItem(tokenKey);
  localStorage.removeItem(profileKey);
}
